/**
 * Plays a subtle notification sound using Web Audio API
 * Generates a gentle "pop" sound without requiring external files
 */
let audioContext = null;

export const playNotificationSound = () => {
  try {
    // Initialize AudioContext if needed
    if (!audioContext) {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }

    // Resume audio context if suspended (required by some browsers)
    if (audioContext.state === "suspended") {
      audioContext.resume().catch((err) => {
        // Silent failure - autoplay policy may block this
        return;
      });
      // If still suspended after resume attempt, return early
      if (audioContext.state === "suspended") {
        return;
      }
    }

    // Create a short, gentle "pop" sound
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    // Connect nodes
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    // Configure sound: gentle pop at 800Hz
    oscillator.frequency.value = 800;
    oscillator.type = "sine";

    // Envelope: quick attack, quick decay
    const now = audioContext.currentTime;
    gainNode.gain.setValueAtTime(0, now);
    gainNode.gain.linearRampToValueAtTime(0.2, now + 0.01); // Quick attack
    gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.1); // Quick decay

    // Play the sound
    oscillator.start(now);
    oscillator.stop(now + 0.1); // Very short duration (100ms)

    // Cleanup
    oscillator.onended = () => {
      oscillator.disconnect();
      gainNode.disconnect();
    };
  } catch (err) {
    // Fallback: silent failure if Web Audio API is not available
    // This can happen if the user hasn't interacted with the page yet
    // (browser autoplay policy)
    console.warn("🔔 Notification sound not available:", err);
  }
};

